// ======================================================================
// File Name       : contentDistribution
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function sendImportDistributionRequest(data, options) {
  return commonCallApi({
    ...options,
    path: 'fgw2/contentsPermission/EditServiceList',
    data,
    muiltipart: 1,
  });
}

export function sendGetDistributionListFileRequest(PARAM_DEFAULT, options) {
  return commonCallApi({
    path: 'fgw2/contentsPermission/GetServiceListResult',
    data: { ...PARAM_DEFAULT, ...options },
  });
}

export function getCourseStatus(PARAM_DEFAULT) {
  return commonCallApi({
    path: 'contentsPermission/GetCourseStatus',
    data: { ...PARAM_DEFAULT },
  });
}

// Step 11.0.0 START
export function doContentPermissionSyncCourses() {
  return commonCallApi({
    path: 'contentsPermission/SyncCourses',
  });
}

export function doContentPermissionSendSyncContents() {
  return commonCallApi({
    path: 'contentsPermission/SyncContents',
  });
}
// Step 11.0.0 END
